import { HttpMethod, initFetch } from "../../utils/fetcher";
import {
  adaptedToTemplate,
  templatesToAdapted,
  templateToAdapted,
} from "../../adapter/templateAdapter";

export const LOAD_SUCCESS_TEMPLATES = "LOAD_SUCCESS_TEMPLATES";
export const LOAD_FAIL_TEMPLATES = "LOAD_FAIL_TEMPLATES";
export const SAVE_SUCCESS_TEMPLATES = "SAVE_SUCCESS_TEMPLATES";
export const SAVE_FAIL_TEMPLATES = "SAVE_FAIL_TEMPLATES";
export const UPDATE_SUCCESS_TEMPLATES = "UPDATE_SUCCESS_TEMPLATES";
export const UPDATE_FAIL_TEMPLATES = "UPDATE_FAIL_TEMPLATES";
export const DELETE_SUCCESS_TEMPLATES = "DELETE_SUCCESS_TEMPLATES";
export const DELETE_FAIL_TEMPLATES = "DELETE_FAIL_TEMPLATES";

export function loadTemplates() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`templates`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.template);
          dispatch({
            type: LOAD_SUCCESS_TEMPLATES,
            payload: templatesToAdapted(res.template),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_TEMPLATES,
            error: err,
          });
        });
    });
  };
}

export function saveTemplate(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`templates`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToTemplate(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(templateToAdapted(res.template));
          dispatch({
            type: SAVE_SUCCESS_TEMPLATES,
            payload: templateToAdapted(res.template),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_TEMPLATES,
            error: err,
          })
        );
    });
  };
}

export function updateTemplate(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`templates/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToTemplate(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(templateToAdapted(res.template));
          dispatch({
            type: UPDATE_SUCCESS_TEMPLATES,
            payload: templateToAdapted(res.template),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_TEMPLATES,
            error: err,
          })
        );
    });
  };
}

export function deleteTemplate(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`templates/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.template);
          dispatch({
            type: DELETE_SUCCESS_TEMPLATES,
            payload: templateToAdapted(res.template),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_TEMPLATES,
            error: err,
          });
        });
    });
  };
}
